import * as Sentry from '@sentry/react';

// Telemetry for the isUsingAccessCode localStorage flag (issue #4641).
//
// The flag duplicates state the server owns (access_code_entries), and the two
// failure directions are invisible in server data:
//   - HOME-FLIP: the home page unconditionally sets the flag false, silently
//     de-authenticating a mid-session customer (their re-entry is deduped
//     server-side, so history can't count it).
//   - STALE-SHOW / STALE-HIDE: the flag contradicts what the API actually
//     authorized (poses arriving with vs without image URLs).
// These events give the precise rate ahead of the derive-from-server fix.
// Measurement only -- never changes behavior; every path is exception-safe.

const once = new Set();

const capture = (event, extra = {}) => {
  try {
    // Once per event type per pageview -- rates, not floods.
    if (once.has(event)) return;
    once.add(event);
    Sentry.captureMessage(`accessFlag:${event}`, {
      level: 'info',
      tags: { accessFlagTelemetry: event },
      extra,
    });
  } catch (_) { /* telemetry must never break the flow */ }
};

// Home page mounted while the flag was true: the unconditional set-false that
// follows is de-authenticating a live session. Call BEFORE the flag is written.
export const recordHomeFlip = () => {
  try {
    if (localStorage.getItem('isUsingAccessCode') === 'true') {
      capture('home-flip-while-authenticated');
    }
  } catch (_) { /* private mode */ }
};

// A pose payload landed. Compare what the SERVER authorized (URLs present)
// with what the client flag believes. Either contradiction is the bug class.
export const recordPosePayloadCheck = (poses) => {
  try {
    if (!Array.isArray(poses) || poses.length === 0) return;
    const flag = localStorage.getItem('isUsingAccessCode') === 'true';
    const serverAuthorized = poses.some((p) => p && (p.watermarkUrl || p.imageUrl));
    if (flag && !serverAuthorized) capture('flag-true-server-denied', { poseCount: poses.length });
    if (!flag && serverAuthorized) capture('flag-false-server-authorized', { poseCount: poses.length });
  } catch (_) { /* never interfere */ }
};
